var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tabs",
    {
      model: {
        value: _vm.activeTab,
        callback: function ($$v) {
          _vm.activeTab = $$v
        },
        expression: "activeTab",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "饮片", name: "1" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData.activeDiagRecord[
                  "chmedPrescriptionItemList"
                ],
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "materielCode",
                  label: "药品编码",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "materielName",
                  label: "药品名称",
                  align: "center",
                },
              }),
              _c("table-select-item", {
                attrs: {
                  edit: false,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "单剂数量",
                  code: "singleNum",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总数量",
                  code: "sellingNum",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "单价",
                  code: "salePrice",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总价",
                  code: "saleAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "中成药", name: "2" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData.activeDiagRecord["medPrescriptionItemList"],
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  prop: "materielCode",
                  label: "药品编码",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  prop: "materielName",
                  label: "药品名称",
                  align: "center",
                },
              }),
              _c("table-select-item", {
                attrs: {
                  width: 140,
                  edit: false,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  code: "sellingNum",
                  name: "销售数量",
                  edit: false,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  prop: "medAdvice",
                  label: "医嘱",
                  align: "center",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  code: "dayNum",
                  name: "用药天数",
                  edit: false,
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  code: "dayFreq",
                  name: "每日次数",
                  edit: false,
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  code: "freqNum",
                  name: "每次剂量",
                  edit: false,
                },
              }),
              _c("table-number-item", {
                attrs: { code: "salePrice", name: "单价", edit: false },
              }),
              _c("table-number-item", {
                attrs: { code: "saleAmount", name: "总价", edit: false },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "理疗项目", name: "3" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData.activeDiagRecord[
                  "servePrescriptionItemList"
                ],
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "materielCode", label: "编码", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { prop: "materielName", label: "名称", align: "center" },
              }),
              _c("ik-column-number", {
                attrs: {
                  "column-width": 120,
                  edit: false,
                  code: "sellingNum",
                  name: "销售数量",
                },
              }),
              _c("ik-column-number", {
                attrs: {
                  "column-width": 120,
                  edit: false,
                  code: "salePrice",
                  name: "单价",
                },
              }),
              _c("ik-column-number", {
                attrs: {
                  "column-width": 120,
                  edit: false,
                  code: "saleAmount",
                  name: "总价",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "代煎处方", name: "4" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData.activeDiagRecord["djPrescriptionItemList"],
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "materielCode",
                  label: "药品编码",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "materielName",
                  label: "药品名称",
                  align: "center",
                },
              }),
              _c("table-select-item", {
                attrs: {
                  edit: false,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "单剂数量",
                  code: "singleNum",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总数量",
                  code: "sellingNum",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "单价",
                  code: "salePrice",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总价",
                  code: "saleAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "代售处方", name: "5" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData.activeDiagRecord["dsPrescriptionItemList"],
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "materielCode",
                  label: "药品编码",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "materielName",
                  label: "药品名称",
                  align: "center",
                },
              }),
              _c("table-select-item", {
                attrs: {
                  edit: false,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总数量",
                  code: "sellingNum",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "单价",
                  code: "salePrice",
                },
              }),
              _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 2,
                  edit: false,
                  name: "总价",
                  code: "saleAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }